import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { AuthProvider } from '@/context/AuthContext';
import { CartProvider } from '@/context/CartContext';
import { Layout } from '@/components/Layout';

import Home from '@/pages/Home';
import Shop from '@/pages/Shop';
import ProductDetail from '@/pages/ProductDetail';
import VinLookup from '@/pages/VinLookup';
import AiMechanic from '@/pages/AiMechanic';
import Reviews from '@/pages/Reviews';
import Join from '@/pages/Join';
import Cart from '@/pages/Cart';
import CheckoutSuccess from '@/pages/CheckoutSuccess';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import Account from '@/pages/Account';
import Admin from '@/pages/Admin';
import AdminLogin from '@/pages/AdminLogin';

function App() {
    return (
        <div className="App rrm-bg-carbon">
            <AuthProvider>
                <CartProvider>
                    <BrowserRouter>
                        <Layout>
                            <Routes>
                                <Route path="/" element={<Home />} />
                                <Route path="/shop" element={<Shop />} />
                                <Route path="/product/:id" element={<ProductDetail />} />
                                <Route path="/vin" element={<VinLookup />} />
                                <Route path="/ai-mechanic" element={<AiMechanic />} />
                                <Route path="/reviews" element={<Reviews />} />
                                <Route path="/join" element={<Join />} />
                                <Route path="/cart" element={<Cart />} />
                                <Route path="/checkout/success" element={<CheckoutSuccess />} />
                                <Route path="/login" element={<Login />} />
                                <Route path="/register" element={<Register />} />
                                <Route path="/account" element={<Account />} />
                                <Route path="/admin/login" element={<AdminLogin />} />
                                <Route path="/admin" element={<Admin />} />
                            </Routes>
                        </Layout>
                    </BrowserRouter>
                    <Toaster position="top-right" theme="dark" />
                </CartProvider>
            </AuthProvider>
        </div>
    );
}

export default App;
